import { Tooltip } from "antd";
import { stringFromDollars } from "@vyne-shared/utils/currency";
import icon_graph_decrease from "assets/arMetrics/graph-decrease.svg";
import icon_graph_increase from "assets/arMetrics/graph-increase.svg";

interface PaymentsMetricsChangeProps {
    percentChange: number | null;
    valueChange: number | null;
    dayDifference: number;
}

/*
 * Displays the change in payments metrics for a specific time period.
 * @param percentChange - The percentage change in the metric.
 * @param valueChange - The absolute value change in the metric.
 * @param dayDifference - The number of days in the selected time period.
 * @returns An element displaying the change with a wrapping tooltip.
 */
export const PaymentsMetricsChange = ({ percentChange, valueChange, dayDifference }: PaymentsMetricsChangeProps) => {
    // Round percentChange to whole number, and account for unusual rounding of negative numbers
    const roundedPercent =
        percentChange !== null ? Math.sign(percentChange) * Math.round(Math.abs(percentChange)) : null;

    if (!roundedPercent || !valueChange) {
        return null;
    }

    const didIncrease = roundedPercent > 0;

    return (
        <Tooltip
            title={`Your AR in the selected range is ${stringFromDollars(
                Math.abs(valueChange),
            )} ${didIncrease ? "higher" : "lower"} than in the previous ${dayDifference} day${dayDifference !== 1 ? "s" : ""}.`}
            placement="bottom"
        >
            <div className="metric-change">
                <span className={`percent-change ${didIncrease ? "percent-increase" : "percent-decrease"}`}>
                    {didIncrease ? (
                        <img src={icon_graph_increase} alt="Increase" />
                    ) : (
                        <img src={icon_graph_decrease} alt="Decrease" />
                    )}
                    <span className="percent-change-text">{Math.abs(roundedPercent)}%</span>
                </span>
                <span className="metric-change-text">
                    from {dayDifference} day{dayDifference !== 1 ? "s" : ""} prior
                </span>
            </div>
        </Tooltip>
    );
};
